var GoldMatchAddStepShareRedirector = xClass("GoldMatchAddStepShareRedirector", BaseRedirector)
GoldMatchAddStepShareRedirector.prototype.getName = function () {
    var self = this
    return "goldMatchAddStepShare"
}
GoldMatchAddStepShareRedirector.prototype.hasHighPriorityAction = function () {
    return false
}
GoldMatchAddStepShareRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param
    var um = UserManager.getInstance();
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }
    if (um.uid && param.inviteCode && param.shareId) {
        let http = GoldMatchShareClickHttp.new();
        http.addEventListener(Events.kComplete, () => {
            Toast.make(getText("gold.mode.helpfailed.tip4"));
        })
        http.addEventListener(Events.kError, (evt = {}) => {
            Toast.make(quickGetErrorText(evt.data, "帮助链接已经失效！"));
        })
        http.load(um.uid, param.inviteCode, param.shareId);
    }
    return true
}
module.exports = GoldMatchAddStepShareRedirector
